import fireErrorAnalytics from '@atlassian/jira-errors-handling/src/utils/fire-error-analytics.tsx';

export const fireFieldUpdateErrorAnalytics = () => {
	fireErrorAnalytics({
		meta: {
			id: 'jira.releases.launch.card.update.version.field.mutation.error.id',
			packageName: 'jiraSoftwareReleasesLaunchCard',
			teamName: 'nova',
		},
		error: Error('Unable to update version'),
		sendToPrivacyUnsafeSplunk: true,
	});
};
